export default "__VITE_ASSET__f9c33d2b__"